import React, { Component } from 'react';
import '../../../src/styles/Journals.css';
import Modal from 'react-bootstrap/Modal'
import { Button } from 'react-bootstrap';
import '../../../src/styles/ModelPopup.css';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { appService } from '../../_services';
import ChapterModal from 'react-bootstrap/Modal'
import { authHeader, config } from '../../_helpers';
import DocumentMeta from 'react-document-meta';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Redirect, Route } from 'react-router-dom';
import * as axios from 'axios';
import EmailModal from 'react-bootstrap/Modal';
import { Page } from 'react-pdf';
import { Document } from 'react-pdf/dist/entry.webpack';
import { Maintenance } from '../Maintenance/Maintenance.jsx';
import ReactGA from 'react-ga';
import PeerReview from './Subitems/PeerReview';

var volumeData, getIssue, Article, parameters, authorFullName, CitationAuthors;
let params = '', nextid = '', url = '', docidparam = '', previd = '', Emailparameters = "", PDFExtract = '';
var productDetailId = '', productId = '', issueId = '', docid = '', PubDate = '', useragent = navigator.userAgent;
let DipslayExtractPdf = '';
let meta = '', authorNames = ''
var setpdfpadding = {
    paddingLeft: '45px'
}
var Displaystyle = {
    display: 'inline-block'
}
var Fright = {
    float: 'right'
}

var paddset = {
    marginLeft: '45%'
}

export class JournalsArticle extends Component {
    displayName = JournalsArticle.name

    constructor(props) {
        super(props);
        this.state = { //this is a temporary fix for hiding/showing links if not logged in -  condition will be modified 
            login: false, Subscribed: false,
            show: false,
            Authors: "",
            articleFirstPage: "",
            articleLastPage: "",
            journalTopic: "",
            volumeNo: "",
            issueNo: "",
            issueText: '',
            issueTextNo: '',
            email: 'dawn.danish@wolterskluwer.com',
            journalTitle: '',
            JournalId:0,
            OnlinePrice: '',
            printedmaterial: '',
            PdfPrice: '',
            user: '', TopicId: '', TopicName: '', newcurrency: '',
            copied: false,
            redirectToSearch: false,
            Isfree: false,
            IsSample: false,
            searchAuthor: ""
        }
        this.state = {
            checked: false,
            checked1: true,
            journalArticles: [],
            imageUrl: [],
            journalIssues: [],
            articlesList: [],
            authorsList: [],
            articleTitle: [],
            productprice: [],
            link: '', numPages: null,
            pageNumber: 1,
            PDFData: '', emailRec: '', emailName: '', Publishedyear: '', PublicationMon: '', Reviewedyear: '', ReviewedMon: '', IsError: false,
            redirectToLogin: false
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChange1 = this.onChange1.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleChapterBuyModalShow = this.handleChapterBuyModalShow.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.handleChapterModalShow = this.handleChapterModalShow.bind(this);
        this.handleChapterModalClose = this.handleChapterModalClose.bind(this);
        this.searchAuthorContent = this.searchAuthorContent.bind(this);
        this.getJournalArticle = this.getJournalArticle.bind(this);
        this.handleEmailModalShow = this.handleEmailModalShow.bind(this);
        this.handleEmailModalClose = this.handleEmailModalClose.bind(this);
        this.sendShareByEmail = this.sendShareByEmail.bind(this)
        this.handleEmailValidation = this.handleEmailValidation.bind(this);
        this.logoutsession = this.logoutsession.bind(this);
        this.handleEtocModalShow = this.handleEtocModalShow.bind(this);
        this.handleEtocModalClose = this.handleEtocModalClose.bind(this);
    }
    handleEtocModalClose() {
        this.setState({ handleEtocModalShow: false });
    }

    handleEtocModalShow() {
        this.setState({ handleEtocModalShow: true });
    }
    logoutsession() {

        var self = this;
        if (localStorage.getItem('user') !== null) {
            appService.getAll('/User/logOutDecreseActiveCount').then(function (response) {
                appService.getAll('/User/logOut').then(function (response) {

                    //localStorage.removeItem('user');
                    //localStorage.removeItem('userId');
                    //localStorage.removeItem('usersubscription');
                    //localStorage.removeItem('company');
                    //localStorage.removeItem('firstName');
                    //localStorage.removeItem('lastName');
                    //localStorage.removeItem('salesForceID');
                    localStorage.clear();
                    localStorage.setItem('logoutclick', 'true');

                });
                window['LastURL'] = '';
            });

        }
        self.setState({
            redirectToLogin: true
        })
    }
    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }
    handleEmailValidation() {
        var self = this;
        let fields = self.state.fields;
        let errors = {};
        let formIsValid = true;

        var emailTo = this.refs["email"].value;

        if (emailTo == "") {
            formIsValid = false;
            this.state.emailRec = "* Required field";
        }

        if (emailTo != "") {
            var emails = emailTo.split(";");
            emails.forEach(function (emails) {
                let lastAtPos = emails.lastIndexOf('@');
                let lastDotPos = emails.lastIndexOf('.');

                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emails.indexOf('@@') == -1 && lastDotPos > 2 && (emails.length - lastDotPos) > 2)) {
                    formIsValid = false;
                    self.state.emailRec = "* Please enter a valid email address";
                }
            })
        }
        self.setState({ errors: errors });

        return formIsValid;

    }

    sendShareByEmail() {
        if (this.handleEmailValidation()) {
            this.state.emailRec = '';
            Emailparameters = {
                Email: this.refs["email"].value,
                Subject: this.refs["SubjectTitle"].value == "" ? this.state.journalTitle : this.refs["SubjectTitle"].value,
                Category: window.location.href,
                AdditionalInfo: this.refs["AddInfo"].value
            }
            var self = this;
            appService.submit('/Email/ShareByEmail', Emailparameters)
                .then(function (data) {
                    if (data == "Success") {
                        self.setState({ handleEmailModalShow: false });
                    }
                });
        }
    }

    decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }


    openInNewTab(url) {

        //var prdTitle = typeof this.props.match.params.title != "undefined" ? this.props.match.params.title.replace(/\+/g, " ") : "";

        //if (this.state.Isfree) {
        //    var eventType = "full-text pdf";

        //    if (this.state.articleTypeId == 44) //Index
        //    {
        //        eventType = "all_issues";
        //    }
        //    else if (this.state.articleTypeId == 27) //for Editorial
        //    {
        //        eventType = "journal_abstract";
        //    }
        //    else if (this.state.articleTypeId == 7 && this.state.journalIssues.id == 2 && this.state.articleTitle.toLowerCase() == "survey of literature") //for Others type
        //    {
        //        eventType = "sample_content";
        //    }

        //    if (localStorage.getItem('user') !== null) {
        //        window['NTPT_PGEXTRA'] = 'event_type=' + eventType + ' &ProductId=' + this.state.journalIssues.id + ' &ProductTitle=' + prdTitle + ' &volume=' + this.props.match.params.volume + ' &issue=' + this.props.match.params.issue + ' &article_id=' + this.props.match.params.id + ' &article_title= ' + this.state.articleTitle + '&authors=' + CitationAuthors + '&user_id=' + localStorage.getItem('salesForceID') + '&user=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //        const script = document.createElement("script");
        //        script.src = "/siqpagetag.js";
        //        script.async = true;
        //        document.body.appendChild(script);
        //    }
        //    else {
        //        window['NTPT_PGEXTRA'] = 'event_type=' + eventType + ' &ProductId=' + this.state.journalIssues.id + ' &ProductTitle=' + prdTitle + ' &volume=' + this.props.match.params.volume + ' &issue=' + this.props.match.params.issue + ' &article_id=' + this.props.match.params.id + ' &article_title= ' + this.state.articleTitle + '&authors=' + CitationAuthors + '&Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //        const script = document.createElement("script");
        //        script.src = "/siqpagetag.js";
        //        script.async = true;
        //        document.body.appendChild(script);
        //    }
        //}
        ////else if (this.state.IsSample) {
        ////    if (localStorage.getItem('user') !== null) {
        ////        window['NTPT_PGEXTRA'] = 'event_type=&ProductId=' + this.state.journalIssues.id + ' &ProductTitle=' + prdTitle + ' &volume=' + this.props.match.params.volume + ' &issue=' + this.props.match.params.issue + ' &article_id=' + this.props.match.params.id + ' &article_title= ' + this.state.articleTitle + '&authors=' + CitationAuthors + '&user_id=' + localStorage.getItem('salesForceID') + '&user=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        ////        const script = document.createElement("script");
        ////        script.src = "/siqpagetag.js";
        ////        script.async = true;
        ////        document.body.appendChild(script);
        ////    }
        ////    else {
        ////        window['NTPT_PGEXTRA'] = 'event_type=&ProductId=' + this.state.journalIssues.id + ' &ProductTitle=' + prdTitle + ' &volume=' + this.props.match.params.volume + ' &issue=' + this.props.match.params.issue + ' &article_id=' + this.props.match.params.id + ' &article_title= ' + this.state.articleTitle + '&authors=' + CitationAuthors + '&Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        ////        const script = document.createElement("script");
        ////        script.src = "/siqpagetag.js";
        ////        script.async = true;
        ////        document.body.appendChild(script);
        ////    }
        ////}
        //else if (localStorage.getItem('user') !== null) {
        //    window['NTPT_PGEXTRA'] = 'event_type=full-text pdf&ProductId=' + this.state.journalIssues.id + ' &ProductTitle=' + prdTitle + ' &volume=' + this.props.match.params.volume + ' &issue=' + this.props.match.params.issue + ' &article_id=' + this.props.match.params.id + ' &article_title= ' + this.state.articleTitle + '&authors=' + CitationAuthors + '&user_id=' + localStorage.getItem('salesForceID') + '&user=' + localStorage.getItem('user') + ' &Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //    const script = document.createElement("script");
        //    script.src = "/siqpagetag.js";
        //    script.async = true;
        //    document.body.appendChild(script);
        //}
        //else {
        //    window['NTPT_PGEXTRA'] = 'event_type=full-text pdf&ProductId=' + this.state.journalIssues.id + ' &ProductTitle=' + prdTitle + ' &volume=' + this.props.match.params.volume + ' &issue=' + this.props.match.params.issue + ' &article_id=' + this.props.match.params.id + ' &article_title= ' + this.state.articleTitle + '&authors=' + CitationAuthors + '&Subscribed=' + this.state.Subscribed + '&platform=klo &useragent=' + useragent;
        //    const script = document.createElement("script");
        //    script.src = "/siqpagetag.js";
        //    script.async = true;
        //    document.body.appendChild(script);
        //}

        //var msg = {
        //    ArticleTitle: window['NTPT_PGEXTRA']
        //}
        //var Logurl = 'Product/LogData';
        //appService.submit(Logurl, msg).then(function (data) {

        //});

        window.open(url);
        //axios(url, {
        //    method: 'GET',
        //    responseType: 'blob', // important
        //}).then((response) => {
        //    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        //    window.open(url);
        //});
    }

    searchAuthorContent = (e) => {
        this.state.searchAuthor = e;
        //window['SearchAuthor'] = e;
        this.setState({ redirectToSearch: true });
    }



    handleChapterModalClose() {
        this.setState({ handleChapterModalShow: false });
    }

    async handleChapterModalShow() {

        if (this.state.checked == false && this.state.checked1 == false) {
            alert('Please choose your subscription ');
        }
        else {

            const requestOptionsCountry = {

                headers: authHeader(),

            };

            const response = await fetch("https://ipapi.co/json/", requestOptionsCountry);
            const json = await response.json();
            this.setState({ currency: json.currency });

            const requestOptions = {
                method: 'POST',
                headers: authHeader(),
                body: {},
            };
            //url = this.props.location.search;
            //params = queryString.parse(url);
            let ProductDetailId = document.location.pathname.split("/")[4];
            var self = this;
            fetch(config.apiUrl + '/Cart/AddToCart?IsProductId=true&ProductDetailId=' + ProductDetailId + '&OnlineThreeMonthsDelivery=' + this.state.checked + '&PrintDelivery=' + this.state.checked1 + '&currency=' + this.state.currency, requestOptions)
                .then(function (data) {
                    self.setState({ handleChapterModalShow: true });
                });
        }
    }

    downloadRIS(url, productDetailId) {
        //creating an invisible element 
        var element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('download', productDetailId + ".ris");
        element.setAttribute('target', '_blank');
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    handleSelect() {
        window.scrollTo(0, 0);

    }
    onChange(e) {
        this.setState({ 'checked': e.target.checked });
    }

    onChange1(e) {
        this.setState({ 'checked1': e.target.checked });
    }
    handleClose() {
        this.setState({ show: false });
    }
    sendEmail() {
        localStorage.setItem('link', JSON.stringify(window.location.href));
        window.scrollTo(0, 0);
    }

    handleEmailModalClose() {
        this.setState({ handleEmailModalShow: false });
    }

    handleEmailModalShow() {
        this.setState({ handleEmailModalShow: true });
    }
    async handleShow() {

        const requestOptionsCountry = {
            headers: authHeader(),
        };
        const response = await fetch("https://ipapi.co/json/", requestOptionsCountry);
        const json = await response.json();
        this.setState({ currency: json.currency });

        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            body: {},
        };
        //url = this.props.location.search;
        //if (this.props.match.params.id) {
        //    productDetailId = this.props.match.params.id
        //} 
        //else 
        //{           
        //    params = queryString.parse(url);
        //    productDetailId = params.Id;
        //}
        let productDetailId = document.location.pathname.split("/")[4];

        var self = this;
        fetch(config.apiUrl + '/Cart/AddToCart?IsProductId=false&ProductDetailId=' + productDetailId + '&OnlineThreeMonthsDelivery=false&BuyChapter=true&PrintDelivery=false&currency=' + this.state.currency, requestOptions).then(function (data) {
            self.setState({ show: true });
        });

    }


    async handleChapterBuyModalShow() {
        const requestOptionsCountry = {
            headers: authHeader(),
        };
        const response = await fetch("https://ipapi.co/json/", requestOptionsCountry);
        const json = await response.json();
        this.setState({ currency: json.currency });

        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            body: {},
        };
        //url = this.props.location.search;
        //params = queryString.parse(url);
        let ProductDetailId = document.location.pathname.split("/")[4];
        var self = this;
        fetch(config.apiUrl + '/Cart/AddToCart?IsProductId=false&ProductDetailId=' + ProductDetailId + '&OnlineThreeMonthsDelivery=false&BuyChapter=true&PrintDelivery=false&currency=' + this.state.currency, requestOptions).then(function (data) {
            self.setState({ show: true });
        });


    }

    getJournalArticle(Id) {

        this.state.user = JSON.parse(localStorage.getItem('user')); //Pradip Lalvani
        parameters = { DocId: Id, user: this.state.user }; //Pradip Lalvani
        var self = this;

        appService.getByArticleId('Product/GetJournalArticle', parameters).then(function (data) {
            if (data == "Error found") {
                // window.location = "/Maintenance";
                self.setState({ IsError: true });
            }
            else {
                self.setState({ journalIssues: data });
                self.setState({ imageUrl: data.imageUrl });
                self.setState({ Isfree: data.isFree });
                self.setState({ journalTopic: data.topic });
                self.setState({ journalTitle: data.title });
                self.setState({JournalId:data.id});
                self.setState({ Subscribed: data.subscribed }); //Pradip Lalvani
                self.setState({ IsSample: data.isSample });
                self.setState({ keywords: data.keywords });
                volumeData = data.volumes;
                productId = data.productid;
                self.setState({ volumeNo: volumeData[0].volumeNo });
                self.setState({ year: volumeData[0].year });
                getIssue = volumeData[0].issues;
                self.setState({ issueNo: getIssue[0].issueNo });
                self.setState({ issueText: getIssue[0].issueText });
                self.setState({ issueTextNo: getIssue[0].issueTextNo });
                self.setState({ articlesList: getIssue[0].articles });
                Article = self.state.articlesList;
                self.setState({ articleTitle: Article[0].title });
                self.setState({ authorsList: Article[0].authors });
                self.setState({ issueId: Article[0].issueId });
                self.setState({ articleExtract: Article[0].extractPageNo });
                self.setState({ articleAbstract: Article[0].articleAbstract });
                self.setState({ articleFirstPage: Article[0].firstPage });
                self.setState({ articleLastPage: Article[0].lastPage });
                self.setState({ productprice: data.productPrice });
                self.setState({ filePath: Article[0].fileName });
                self.setState({ code: Article[0].code });
                self.setState({ articleTypeId: Article[0].articleTypeId });
                self.setState({ doiUrl: data.doiUrl });
                self.setState({ PurchaseUrl: data.purchaseUrl });
                self.setState({ pricePdf: (Math.round(data.articlePrice * 100) / 100).toFixed(2) });
                self.setState({ priceRental: (Math.round(data.rentalPrice * 100) / 100).toFixed(2) });
                self.setState({ TopicId: data.topicId });
                self.setState({ TopicName: data.topic });
                self.setState({ Publishedyear: data.publicationDate });
                self.setState({ PublicationMon: data.publicationMon });

                console.log("link", data.PurchaseUrl)

                fetch("https://ipapi.co/json/")
                    .then(res => res.json())
                    .then(
                        (result) => {
                            //console.log(result)
                            self.setState({ newcurrency: result.currency });
                            //console.log(data.productPrice);
                            if (self.state.productprice != null) {
                                self.state.productprice.map((item) => {
                                    //console.log(self.state.newcurrency);
                                    //console.log(item);
                                    if (self.state.newcurrency == "EURO" || self.state.newcurrency == "INR" || self.state.newcurrency == '') {
                                        if (item != null && item.type == "2") {
                                            self.setState({ OnlinePrice: item.euro });
                                        }
                                        if (item != null && item.type == "3") {
                                            self.setState({ printedmaterial: item.euro });
                                        }
                                        if (item != null && item.type == "1") {
                                            self.setState({ PdfPrice: item.euro });
                                        }
                                    }
                                    else if (self.state.newcurrency == "POUND") {
                                        if (item != null && item.type == "2") {
                                            self.setState({ OnlinePrice: item.pound });
                                        }
                                        if (item != null && item.type == "3") {
                                            self.setState({ printedmaterial: item.pound });
                                        }
                                        if (item != null && item.type == "1") {
                                            self.setState({ PdfPrice: item.pound });
                                        }
                                    }
                                    else {
                                        if (item != null && item.type == "2") {
                                            self.setState({ OnlinePrice: item.usd });
                                        }
                                        if (item != null && item.type == "3") {
                                            self.setState({ printedmaterial: item.usd });
                                        }
                                        if (item != null && item.type == "1") {
                                            self.setState({ PdfPrice: item.usd });
                                        }
                                    }
                                })
                            }

                        });

                nextid = Article[0].nextArticleId;
                previd = Article[0].prevArticleId;
                var prdTitles = typeof self.props.match.params.title != "undefined" ? self.props.match.params.title.replace(/\+/g, " ") : "";

                if (self.state.Isfree) {
                    var eventType = "journal_abstract";

                    if (self.state.articleTypeId == 44) //Index
                    {
                        eventType = "all_issues";
                    }
                    else if (self.state.articleTypeId == 27) //for Editorial
                    {
                        eventType = "journal_abstract";
                    }
                    else if (self.state.articleTypeId == 7 && self.state.journalIssues.id == 2 && self.state.articleTitle.toLowerCase() == "survey of literature") //for Others type
                    {
                        eventType = "sample_content";
                    }

                    if (localStorage.getItem('user') !== null) {
                        window['NTPT_PGEXTRA'] = 'event_type=' + eventType + '&ProductId=' + self.state.journalIssues.id + '&ProductTitle=' + prdTitles + '&volume=' + self.props.match.params.volume + '&issue=' + self.props.match.params.issue + '&article_id=' + self.props.match.params.id + '&articleTitle=' + self.state.articleTitle + '&authors=' + CitationAuthors + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                        const script = document.createElement("script");
                        script.src = "/siqpagetag.js";
                        script.async = true;
                        document.body.appendChild(script);
                    }
                    else {
                        window['NTPT_PGEXTRA'] = 'event_type=' + eventType + '&ProductId=' + self.state.journalIssues.id + '&ProductTitle=' + prdTitles + '&volume=' + self.props.match.params.volume + '&issue=' + self.props.match.params.issue + '&article_id=' + self.props.match.params.id + '&articleTitle=' + self.state.articleTitle + '&authors=' + CitationAuthors + '&User= &Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                        const script = document.createElement("script");
                        script.src = "/siqpagetag.js";
                        script.async = true;
                        document.body.appendChild(script);
                    }

                }
                else {

                    if (localStorage.getItem('user') !== null) {
                        window['NTPT_PGEXTRA'] = 'event_type=journal_abstract&ProductId=' + self.state.journalIssues.id + '&ProductTitle=' + prdTitles + '&volume=' + self.props.match.params.volume + '&issue=' + self.props.match.params.issue + '&article_id=' + self.props.match.params.id + '&articleTitle=' + self.state.articleTitle + '&authors=' + CitationAuthors + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                        const script = document.createElement("script");
                        script.src = "/siqpagetag.js";
                        script.async = true;
                        document.body.appendChild(script);
                    }
                    else {
                        window['NTPT_PGEXTRA'] = 'event_type=journal_abstract&ProductId=' + self.state.journalIssues.id + '&ProductTitle=' + prdTitles + '&volume=' + self.props.match.params.volume + '&issue=' + self.props.match.params.issue + '&article_id=' + self.props.match.params.id + '&articleTitle=' + self.state.articleTitle + '&authors=' + CitationAuthors + '&User= &Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                        const script = document.createElement("script");
                        script.src = "/siqpagetag.js";
                        script.async = true;
                        document.body.appendChild(script);
                    }

                }
                var msg = {
                    ArticleTitle: window['NTPT_PGEXTRA']
                }
                var Logurl = 'Product/LogData';
                appService.submit(Logurl, msg).then(function (data) {

                });

                DipslayExtractPdf = <Document
                    file={{ url: '/api/Product/GetArticlePDF?file=Journals\\' + self.state.code + "\\" + self.state.filePath }} renderMode="svg">
                    <Page pageNumber={self.state.pageNumber} />
                </Document>

                ReactGA.initialize(
                    [
                        {
                            trackingId: 'UA-2905701-8',
                            gaOptions: { name: 'tracker1' }
                        },
                        {
                            trackingId: 'UA-72849501-2',
                            gaOptions: { name: 'tracker2' }
                        }
                    ],
                    { alwaysSendToDefaultTracker: false }
                );

                ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], Article[0].title + " - Kluwer Law Online");

                var metas = document.getElementsByTagName('meta');
                for (let i = 0; i < metas.length; i++) {
                    if (metas[i].getAttribute('name') == "robots") {
                        console.log(metas[i]);
                        metas[i].remove();
                    }
                }
            }
        })
    }

    componentDidMount() {

        productDetailId = document.location.pathname.split("/")[4];
        //Pradip Lalvani
        if (localStorage.getItem('user') !== null) {
            this.state.login = true;
        }
        else {
            this.state.login = false;
        }
        url = this.props.location.search;
        if (this.props.match.params.id) {
            this.getJournalArticle(this.props.match.params.id);
        }
        else {
            params = queryString.parse(url);
            if (params.id) {
                var self = this;
                appService.getById('Product/GetProductDetailId?documentId=', params.id)
                    .then(function (data) {
                        if (data == "Error found") {
                            //window.location = "/Maintenance";
                            self.setState({ IsError: true });
                        }
                        else {
                            var id = parseInt(data);
                            self.getJournalArticle(id);

                        }
                    })
            }
        }
        //params = queryString.parse(url);



    }



    render() {
        if (this.state.redirectToLogin) {
            this.setState({ redirectToLogin: false });
            return <Redirect to={"/Login"} />
        }
        if (this.state.IsError != true) {
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];

            if (this.state.redirectToSearch) {
                this.setState({ redirectToSearch: false });
                return <Redirect to={"/SearchContent/query=?authorString=" + this.state.searchAuthor} />;
            }

            authorNames = this.state.authorsList != null && this.state.Authors != 'undefined' && this.state.authorsList.map((authoritem, index) => {
                return index == 0 ?
                    <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}> <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                    </span >
                    :
                    <span onClick={() => this.searchAuthorContent(authoritem.firstName + " " + authoritem.surname)}>, <span className="HoverUnderline">{this.decodeHtml(authoritem.firstName) + " " + this.decodeHtml(authoritem.surname)}</span>
                    </span >
            })

            CitationAuthors = "";
            if (this.state.authorsList != null && this.state.authorsList != 'undefined') {
                this.state.Authors = Object.entries(this.state.authorsList).map((authoritem, index) => {
                    authorFullName = this.decodeHtml(authoritem[1].firstName) + " " + this.decodeHtml(authoritem[1].surname);
                    CitationAuthors += index == 0 ? authorFullName : ", " + authorFullName;
                    return <span className="LinkClass">{(index ? ', ' : '') + authorFullName}</span>
                })
            }

            var journalTitlePlus = typeof this.state.journalTitle == 'undefined' ? "" : this.state.journalTitle.replace(/ /g, "+");

            meta = {
                title: this.state.articleTitle + " - Kluwer Law Online",
                //description: "View " + this.state.articleTitle + " by " + authorFullName + " - " + this.props.match.params.title + "",
                canonical: window.location.href,
                //meta: {
                //    charset: "utf-8",
                //    name: {
                //        citation_title: this.state.articleTitle,
                //        citation_journaltitle: this.props.match.params.title,
                //        citation_author: authorFullName,
                //       // citation_publicationdate: monthNames[this.state.PublicationMon - 1] + ' ' + this.state.Publishedyear,
                //        citation_volume: this.state.volumeNo,
                //        citation_issue: this.state.issueNo,
                //        citation_number: this.props.match.params.id,
                //        citation_pdf_url: window.location.origin+'/api/Product/RenderPDF?file=Journals/'+this.state.code+"/"+ this.state.filePath,
                //        title: this.state.articleTitle + "-" + this.props.match.params.title,
                //        description: "View " + this.state.articleTitle + " by " + authorFullName + " - " + this.props.match.params.title+""
                //    }
                //}
            }
        }

        return (
            this.state.IsError != true ?
                <DocumentMeta {...meta}>
                    <div>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-lg-12">
                                    <p className="TitlePadding" style={{ paddingLeft: '4%' }}>
                                        <span><Link to="/" className="LinkClass">Home</Link> > <Link className="LinkClass" to="/AllJournals"> All journals </Link> > <Link to={"/Journals/" + journalTitlePlus + "/" + this.state.journalIssues.id} dangerouslySetInnerHTML={{ __html: this.state.journalTitle }} onClick={this.handleSelect}></Link> </span> > <Link onClick={this.handleSelect} className="LinkClass" to={"/journalIssue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.issueTextNo + "/" + this.state.issueId} >{this.state.volumeNo}({this.state.issueTextNo})</Link> > <div style={{ display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: this.state.articleTitle }}></div>
                                    </p>
                                </div>
                            </div>
                            <div className="row AllColPadding margintop">

                                <div className="col-lg-2 TopicPadding">
                                    <img alt={"Cover image of" + this.state.journalTitle} src={"/../../images/books/" + this.state.imageUrl} className="Setwdth" style={{ border: '1px solid #CCCCCC' }} />
                                    {((!this.state.login && !this.state.Subscribed) || (this.state.login && !this.state.Subscribed)) && !(this.state.doiUrl == null) ?
                                        <div>
                                            <p className="center" style={{ marginTop: '10%', marginBottom: '6%', display: 'block' }}>
                                                <span style={{ color: '#85BC20' }}>${this.state.priceRental}</span> - Rental (PDF) *</p>
                                            <p className="center" style={{ marginTop: '5%', marginBottom: '8%', display: 'block' }}>
                                                <span style={{ color: '#85BC20' }}>${this.state.pricePdf}</span> - Article (PDF) *</p>
                                        </div>
                                        : null}
                                    {((!this.state.login && !this.state.Subscribed) || (this.state.login && !this.state.Subscribed)) && !(this.state.doiUrl == null) ?
                                        <div>
                                            <Button style={{ display: 'block' }} variant="primary" id="btnBuyChapter" onClick={() => window.open(this.state.PurchaseUrl, "_blank")} className="btn btn-info next Setwdth">
                                                Buy article <img alt="" src=" /../../images/cart-down.svg" className="ButtonImage" />
                                            </Button>
                                            <i style={{ marginTop: '4%', marginBottom: '6%', marginRight: '6%', textAlign: 'center', color:'#9d9d9d', display: 'block' }}>
                                            *service fee may apply
                                            </i>
                                        </div> : null}
                                    <Modal show={this.state.show} onHide={this.handleClose}  {...this.props}
                                        size="lg"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered>
                                        <Modal.Header closeButton className="Popupcolor">
                                            <Modal.Title>Journal article added to cart</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className="row AllColPadding margintop">

                                                <div className="col-sm-3 TopicPadding">
                                                    <img alt={"Cover image of" + this.state.journalTitle} src={"/../../images/books/" + this.state.imageUrl} className="Setwdth" style={{ border: '1px solid #CCCCCC' }} />
                                                </div>

                                                <div className="col-sm-9 TopicPadding ">

                                                    <h1 className="paddingL PublicationTitle SetjournalArtimargin">

                                                        {(this.state.login == true && this.state.Subscribed) || this.state.Isfree ?
                                                            this.state.Isfree ?
                                                                <div>
                                                                    <div className="LinkClass HoverUnderline" style={{ position: 'absolute' }} onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Journals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                                        <img alt="Download the PDF icon" src={"/../../images/pdf-icon-with-text.svg"} />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div>
                                                                    <div className="LinkClass HoverUnderline" style={{ position: 'absolute' }} onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Journals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                                        <img alt="Download the PDF icon" src={"/../../images/pdf-icon-with-text.svg"} />
                                                                    </div>
                                                                </div>
                                                            : null}

                                                        <div style={(this.state.login == true && this.state.Subscribed) || this.state.IsFree ? setpdfpadding : null}>
                                                            <h1 dangerouslySetInnerHTML={{ __html: this.state.articleTitle }}></h1>
                                                            <span className="LinkClass" style={{ display: 'block' }}>

                                                                {
                                                                    this.state.Authors != null ? this.state.Authors.map((authoritem, index) => {
                                                                        authorFullName = authoritem.props.children;
                                                                        return <span>{authorFullName}</span>
                                                                    }) : null
                                                                }

                                                            </span>

                                                            {
                                                                (this.state.login == true) ?
                                                                    <span style={{ fontSize: '15px', display: 'block' }}>Published Dec 2018, Reviewed Aug 2018</span>
                                                                    :
                                                                    <span style={{ fontSize: '15px', display: 'block' }}>2018</span>
                                                            }
                                                        </div>
                                                        <p>
                                                            <span className="LinkClass" style={{ fontStyle: 'italic' }}>
                                                                <div dangerouslySetInnerHTML={{ __html: this.state.journalTitle }}></div>
                                                            </span>
                                                            <br></br>
                                                            <span className="VolumeDetails"> Volume {this.state.volumeNo}, {this.state.issueText != null ? this.state.issueText : "Issue " + this.state.issueNo} ({this.state.year}) pp. {this.state.articleFirstPage}–{this.state.articleLastPage}
                                                            </span>
                                                        </p>
                                                        <span style={{ color: '#85BC20', fontSize: '18px', display: 'none' }}>€{this.state.PdfPrice}</span> <span style={{ fontSize: '18px' }}></span>- PDF


                                                    </h1>

                                                </div>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <div className="row AllColPadding">
                                                <div className="col-sm-8 TopicPadding ">
                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleClose}>  Return to site </span>
                                                </div>
                                                <div className="col-sm-4 TopicPadding">
                                                    <a variant="primary" className="btn btn-info next FloatSet" href="/ShoppingCart">
                                                        Go to shopping cart
                                                    </a></div>
                                            </div>
                                        </Modal.Footer>
                                    </Modal>



                                </div>
                                <div className="col-lg-6 TopicPadding " style={{ minWidth: '56%' }}>
                                    <div className="row">
                                        <div className="paddingL PublicationTitle" style={{ width: '100%' }}>
                                            {((this.state.login == true && this.state.Subscribed) || this.state.Isfree) ?
                                                (this.state.Isfree == true) ?
                                                    <div>
                                                        <div className="LinkClass HoverUnderline" style={{ position: 'absolute' }} onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Journals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                            <img alt="Download the PDF icon" src={"/../../images/pdf-icon-with-text.svg"} />
                                                        </div>
                                                    </div>
                                                    :
                                                    <div>
                                                        <div className="LinkClass HoverUnderline" style={{ position: 'absolute' }} onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Journals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                            <img alt="Download the PDF icon" src={"/../../images/pdf-icon-with-text.svg"} />
                                                        </div>
                                                    </div>

                                                : null}

                                            <div id="Pdftitle" style={((this.state.login == true && this.state.Subscribed) || this.state.Isfree) ? setpdfpadding : null}>
                                                {((this.state.login == true && this.state.Subscribed) || this.state.Isfree) ?
                                                    this.state.Isfree == true ?
                                                        <div className="LinkClass HoverUnderline" onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Journals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                            <h1 style={{ fontSize: '20px', display: 'contents' }} dangerouslySetInnerHTML={{ __html: this.state.articleTitle }}>
                                                            </h1> {this.state.Subscribed == true ? <img alt="" src={"/../../images/green-tick.svg"} /> : null}
                                                        </div>
                                                        :
                                                        <div className="LinkClass HoverUnderline" onClick={() => this.openInNewTab('api/Product/CitationPDFURL?file=Journals\\' + this.state.code + "\\" + this.state.filePath)}>
                                                            <h1 style={{ fontSize: '20px', display: 'contents' }} dangerouslySetInnerHTML={{ __html: this.state.articleTitle }}>
                                                            </h1> {this.state.Subscribed == true ? <img alt="" src={"/../../images/green-tick.svg"} /> : null}
                                                        </div>
                                                    :
                                                    <div>
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.articleTitle }}>
                                                        </div>
                                                    </div>
                                                }


                                                <p id="pdflink" className="LinkClass" style={{ display: 'block' }}>
                                                    {
                                                        authorNames
                                                    }

                                                </p>

                                            </div>

                                            <p>
                                                <br></br>
                                                <Link onClick={this.handleSelect} to={"/Journals/" + journalTitlePlus + "/" + this.state.journalIssues.id} style={{ fontStyle: 'italic' }} className="ArticleChapter" dangerouslySetInnerHTML={{ __html: this.state.journalTitle }}></Link>
                                                <br />
                                                <Link to={"/journalissue/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.issueTextNo + "/" + this.state.issueId}>
                                                    <span className="LinkClass VolumeDetails" >Volume {this.state.volumeNo}, {this.state.issueText != null ? this.state.issueText : "Issue " + this.state.issueNo} </span>
                                                </Link> ({this.state.year}) pp. {this.state.articleFirstPage} – {this.state.articleLastPage}
                                            </p>
                                            <p>{this.state.doiUrl}</p>
                                            <CopyToClipboard text={(CitationAuthors !== null ? CitationAuthors : "[null]") + ", '" + this.decodeHtml(this.state.articleTitle) + "', " + "(" + this.state.year + ")" + ", " + this.state.volumeNo + ", " + this.state.journalTitle + ", Issue " + this.state.issueTextNo + ", pp. " + this.state.articleFirstPage + "-" + this.state.articleLastPage + ", " + document.location.href}
                                                onCopy={() => this.setState({ copied: true })}>
                                                <button className="btn BorderBtn">
                                                    {!this.state.copied ? "Copy citation to clipboard" : "Citation copied"}
                                                </button>
                                            </CopyToClipboard>  <button onClick={() => this.downloadRIS('api/Product/GetProductDetailsByDocId?docId=' + productDetailId, productDetailId)} className="btn BorderBtn">Export citation to RIS</button>
                                            <br></br>
                                            <br></br>
                                            {
                                                (this.state.articleAbstract !== '' && this.state.articleAbstract !== null) ?
                                                    <h2><p className="Abstract">Abstract</p></h2>
                                                    :
                                                    null
                                            }
                                            <p className="journalbody" style={{ fontSize: '16px', textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: this.state.articleAbstract }}>

                                            </p>

                                            {
                                                (this.state.keywords !== '' && this.state.keywords !== null) ?
                                                    <div>
                                                        <br></br>
                                                        <h2><p className="Abstract">Keywords</p></h2>
                                                        <p className="journalbody" style={{ fontSize: '16px', textAlign: 'justify', fontStyle: 'italic' }}>
                                                            {this.state.keywords}
                                                        </p>
                                                    </div>
                                                    :
                                                    null
                                            }

                                            <br></br>
                                            {this.state.filePath !== null && this.state.filePath !== '' && this.state.filePath !== undefined
                                                && this.state.code !== null && this.state.code !== undefined ?

                                                <h2>
                                                    <p className="Abstract"> Extract </p>
                                                    <div>
                                                        {DipslayExtractPdf}
                                                    </div>
                                                </h2>

                                                :
                                                null}

                                            <div>
                                                <span style={{ fontSize: '16px', textAlign: 'justify' }}>{this.state.PDFData}</span>
                                            </div>
                                            <br></br>
                                            <br></br>
                                            {
                                                !this.state.Subscribed && !this.state.Isfree ?
                                                    <p className="journalbody" style={{ display: 'none' }}>
                                                        <span style={{ color: '#474747' }} > To read more, you can </span> <span style={{ cursor: 'pointer' }} className="LinkClass HoverUnderline" onClick={this.handleShow}>buy this article</span>.
                                                    </p>
                                                    :
                                                    null
                                            }

                                            <hr className="HrCSS"></hr>

                                            {(() => {
                                                if (previd != null && previd != "") {
                                                    return (
                                                        <div className="pagination" style={(nextid > 0 && nextid == previd) ? Fright : paddset}>
                                                            <Link to={"/journalarticle/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.issueTextNo + "/" + previd}><i className="fa fa-angle-left"><span class="sr-only sr-only-focusable">Arrow button used to open the Previous Article</span></i></Link>
                                                            <Link to={"/journalarticle/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.issueTextNo + "/" + previd} className="paginationpadding" title="Previous">Previous Article</Link>

                                                        </div>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <div></div>
                                                    )
                                                }
                                            }
                                            )()}

                                            {(() => {
                                                if (nextid != null && nextid != "" && nextid !== previd) {
                                                    return (
                                                        <div className="pagination Fright">
                                                            <Link to={"/journalarticle/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.issueTextNo + "/" + nextid} className="paginationpadding" title="Next">Next Article</Link>
                                                            <Link to={"/journalarticle/" + journalTitlePlus + "/" + this.state.volumeNo + "." + this.state.issueTextNo + "/" + nextid}><i className="fa fa-angle-right"><span class="sr-only sr-only-focusable">Arrow button used to open the Next Article</span></i></Link>

                                                        </div>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <div></div>
                                                    )
                                                }
                                            }
                                            )()}


                                        </div>

                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    {(!this.state.login && !this.state.Subscribed) || (this.state.login && !this.state.Subscribed) ?
                                        <div>
                                            <div className="TopicBorder BGGrey" id="Subcribeto" style={{ borderTop: '2px solid #CCCCCC', paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                                <span className="paddingL fontbold margintop SetPaddingforP"> Subscribe to this journal </span>
                                            </div>
                                            <div className="TopicBorder" id="Pricemenu">

                                                <p className="paddingL fontbold" style={{ lineHeight: '3', marginBottom: '3%' }}>Interested in a subscription?
                                                    <Link to="/ContactSales" variant="secondary" style={{ marginTop: '3%', textAlign: 'center' }} className="Modalbutton Setwdth HoverUnderline">  <strong> Contact our sales team</strong> </Link>
                                                </p>
                                            </div>
                                            
                                        </div>
                                        : null}
                                        <PeerReview data={this.state.JournalId}/>
                                    <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                        <span className="paddingL fontbold margintop SetPaddingforP"> Browse by practice area </span>
                                    </div>
                                    <div className="TopicBorder">
                                        <br></br>
                                        {this.state.TopicName !== undefined ?
                                            <Link to={"/PracticeArea?Id=" + this.state.TopicId + "&name=" + this.state.TopicName.replace(/ /g, "+")} onClick={this.handleSelect} className="paddingL LinkClass margintop" style={this.state.TopicName.length > 33 ? Displaystyle : null}>{this.state.TopicName} </Link>
                                            :
                                            null
                                        }
                                        <br></br> <br></br>
                                    </div>
                                    <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                        <span className="paddingL fontbold margintop SetPaddingforP"> Share </span>
                                    </div>
                                    <div className="TopicBorder">
                                        <br></br>
                                        <CopyToClipboard text={document.location.href}>
                                            <span data-tooltip="Share on Linkedin" className="RSSCard Shareicon-margin" >
                                                <a href={"https://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href + "&title=&summary=&source="}
                                                    target="_blank" title="Share on Linkedin">
                                                    <i class="fa fa-linkedin shareicons colPadding btn-fa" aria-hidden="true"></i></a>
                                            </span>
                                        </CopyToClipboard>
                                        <CopyToClipboard text={document.location.href}>
                                            <span data-tooltip="Share on X" className="RSSCard Shareicon-margin" >
                                                <a href={"https://X.com/home?status=" + window.location.href} target="_blank" title="Share on X">
                                                    <b
                                                        class="shareicon-X colPadding btn-fa"
                                                        aria-hidden="true"
                                                    >𝕏</b>
                                                </a>
                                            </span>
                                        </CopyToClipboard>
                                        <CopyToClipboard text={document.location.href}>
                                            <span data-tooltip="Share on Facebook" className="RSSCard Shareicon-margin" >
                                                <a href={"https://www.facebook.com/sharer/sharer.php?u=" + window.location.href}
                                                    target="_blank" title="Share on Facebook">
                                                    <i class="fa fa-facebook shareicon-facebook colPadding btn-fa" aria-hidden="true"></i></a>
                                            </span>
                                        </CopyToClipboard>
                                        {/* <span onClick={this.handleEmailModalShow} className="RSSCard Shareicon-margin" data-tooltip="Share by Email">
                                            <i class="fa fa-envelope shareicons colPadding btn-fa" aria-hidden="true"></i>
                                        </span> */}
                                        <br></br>
                                        <br></br>
                                    </div>
                                    <EmailModal show={this.state.handleEmailModalShow} onHide={this.handleEmailModalClose}  {...this.props}
                                        size="lg"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered>
                                        <EmailModal.Header closeButton className="Popupcolor">
                                            <Modal.Title>
                                                Share by email
                                            </Modal.Title>
                                        </EmailModal.Header>
                                        <EmailModal.Body>
                                            <div>
                                                <div className="row mt-3 AllColPadding">
                                                    <div className="col-lg-6 TopicPadding">
                                                        <label for="To">To</label>
                                                        <input type='email' id="email" name="email" ref="email" className="form-control form-control-sm rounded-0"
                                                            placeholder="Enter your email address(es); separated by semi-colon" />
                                                        <span className="error">{this.state.emailRec}</span>
                                                    </div>
                                                </div>
                                                <div className="row mt-3 AllColPadding">
                                                    <div className="col-lg-6 TopicPadding">
                                                        <label for="SubjectTitle">Subject</label>
                                                        <input type="text" ref="SubjectTitle" className="form-control form-control-sm rounded-0" placeholder={this.state.journalTitle} id="SubjectTitle" name="SubjectTitle" />
                                                    </div>
                                                </div>
                                                <div className="row mt-3 AllColPadding">
                                                    <div className="col-lg-6 TopicPadding">
                                                        <label for="URL" style={{ fontSize: '12px' }}>{window.location.href}</label>
                                                        <textarea
                                                            className="form-control"
                                                            id="addInfo"
                                                            name="addInfo"
                                                            rows="3" placeholder="Enter message" ref="AddInfo"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </EmailModal.Body>
                                        <EmailModal.Footer>
                                            <div className="row AllColPadding">
                                                <div className="col-sm-8 TopicPadding ">
                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleEmailModalClose}>  Return to site </span>
                                                </div>
                                                <div className="col-sm-4 TopicPadding">
                                                    <button variant="primary" className="btn btn-info next FloatSet" onClick={this.sendShareByEmail}>
                                                        Submit
                                                    </button></div>
                                            </div>
                                        </EmailModal.Footer>
                                    </EmailModal>
                                    <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                        <span className="paddingL fontbold margintop SetPaddingforP"> Stay up to date </span>
                                    </div>
                                    <div className="TopicBorder" style={{ paddingBottom: '3%' }}>
                                        <br></br>
                                        <a className="LinkClass RSSCard Shareicon-margin" style={{ cursor: 'pointer' }} href={'feeds/' + this.state.code} target="_blank" title="Open RSS feed" data-tooltip="RSS feed for this title">
                                            <i class="fa fa-rss shareicon-ETOC colPadding btn-fa" aria-hidden="true"></i>
                                        </a>
                                        <Link to="/Etoc" onClick={this.handleSelect} className="RSSCard Shareicon-margin" data-tooltip="Table of contents alert for this title" title="Table of contents alert for this title">
                                            <i class="fa fa-clock-o shareicon-ETOC colPadding btn-fa" aria-hidden="true"></i>
                                        </Link>
                                        <br></br>
                                        <span style={{ fontSize: '11px', color: '#757575', marginLeft: '7%' }}>RSS</span>
                                        <span style={{ fontSize: '11px', color: '#757575', marginLeft: '13%' }}>ETOC</span>
                                        <br></br>
                                    </div>
                                    <EmailModal show={this.state.handleEtocModalShow} onHide={this.handleEtocModalClose}  {...this.props}
                                        size="lg"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered>
                                        <EmailModal.Header closeButton className="Popupcolor">
                                            <Modal.Title>
                                                Table of Contents alert (ETOC)
                                            </Modal.Title>
                                        </EmailModal.Header>
                                        <EmailModal.Body>
                                            <div>
                                                <div className="row mt-6 AllColPadding">
                                                    <div className="col-lg-6 TopicPadding">
                                                        <label>Sign up for ETOC alerts to receive an e-mail informing you when new content for Kluwer Law Online prodcuts is available online. Login or create an account and select the title(s) you wish to subscribe to.</label>

                                                    </div>
                                                </div>

                                            </div>
                                        </EmailModal.Body>
                                        <EmailModal.Footer>
                                            <div className="row AllColPadding">

                                                <div className="col-sm-4 TopicPadding">

                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.logoutsession}>  Login/Create Account </span>
                                                </div>
                                                <div className="col-sm-8 TopicPadding ">
                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleEtocModalClose}>  Return to site </span>
                                                </div>
                                            </div>
                                        </EmailModal.Footer>
                                    </EmailModal>
                                </div>

                            </div>
                            <div className="White">
                            </div>
                        </div>
                    </div>
                </DocumentMeta>
                :
                <Maintenance />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Journals/JournalsArticle.jsx